export type Review = {
  quote: string
  name: string
  role: string
  city: string
  country: string
}

/** Reseñas de coaches e instructores que usan Troop Night Ready. */
export const reviews: Review[] = [
  {
    quote:
      'The team challenge gave everyone a role to play, and I noticed more of the group getting involved instead of waiting for instructions.',
    name: 'Olivia Parker',
    role: 'Outdoor Skills Coach',
    city: 'Vancouver',
    country: 'Canada',
  },
  {
    quote:
      'After the knot-tying activity, several participants were able to demonstrate the sequence we had practiced without me walking them through every step again.',
    name: 'Mason Campbell',
    role: 'Bushcraft Instructor',
    city: 'Halifax',
    country: 'Canada',
  },
  {
    quote:
      'The skill certificates gave us a simple way to recognize what the group had learned and celebrate their progress at the end of the session.',
    name: 'Amelia Carter',
    role: 'Survival Skills Coach',
    city: 'Cardiff',
    country: 'United Kingdom',
  },
  {
    quote:
      'I use it alongside our existing programme as a ready-to-run structure for practical activities, team challenges and games.',
    name: 'Sophie Bennett',
    role: 'Outdoor Learning Coach',
    city: 'Bristol',
    country: 'United Kingdom',
  },
  {
    quote:
      'I choose the meetings that fit our group and map the skills to the awards and requirements we already work towards.',
    name: 'Ethan Brooks',
    role: 'Outdoor Skills Instructor',
    city: 'Denver',
    country: 'United States',
  },
  {
    quote:
      'The age adjustments help me adapt an activity for our younger and older participants without having to start with two completely different plans.',
    name: 'Tyler Bennett',
    role: 'Outdoor Education Instructor',
    city: 'Portland',
    country: 'United States',
  },
]
